export const NEUTRAL_MARK = {
  viewBox: "0 0 120 120",
  inset: 8,
  size: 104,
  radius: 28,
  glyph: "M40 42L62 60L40 78M68 80H88",
  strokeWidth: 11,
} as const;
